import { useCallback, useState } from "react"
import { retrieveConfigs } from "src/pages/admin/services/whitelistService"

export type Configs = {
  baseCount?: number,
  growthIntervalMs?: number,
  growthMax?: number,
  growthMin?: number,
  startAt?: number,
  endAt?: number,
  earlyAccessAt?: number
  earlyBirdPoolTotalUsdc?: number
  earlyBirdPerUserUsdc?: number
  earlyBirdMinVolumeUsdc?: number
  earlyBirdTopN?: number
  unlockVolumeUsdc?: number
  referralMinTradeUsdc?: string
  marketingShowcaseQuota?: number
}

const useConfigs = () => {

  const [configsData, setConfigsData] = useState<Configs>()

  const retrieve = useCallback(async () => {
    try {
      const response = await retrieveConfigs()
      setConfigsData(response)
    } catch (error) {
      console.log("retrive candidate error: ", error)
      throw error
    }
  }, [])

  return {
    configsData,
    retrieve
  }
}

export default useConfigs